import { AuthManagerBase, ErrorHandlerResult } from "./managerBase";
import { NextLink, Operation } from "@apollo/client";
import { BackendErrorCode } from "../types";
import { setBackendError } from "../actions";

export class ConferenceManager extends AuthManagerBase {
    handleGraphQLError(code: BackendErrorCode, _operation: Operation, _forward: NextLink): ErrorHandlerResult {
        if (code === "unknown_invitation") {
            this.store.dispatch(setBackendError({ code }));
            return { handled: true };
        }

        return {};
    }

    static getToken(): string {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("invitation");
    }

    get userName(): string {
        return "";
    }

    async login(): Promise<void> {
        console.error("'login' in conference auth manager");
    }

    async refreshToken(): Promise<void> {
        console.error("'refreshToken' in conference auth manager");
    }

    get authHeader(): string {
        return `Invitation ${ConferenceManager.getToken()}`;
    }

    get isLoggedIn(): boolean {
        return !!ConferenceManager.getToken();
    }
}
